/**
 * Returns a short abbreviation for a DTE code.
 * @param {string|number} code - DTE code (33, 34, 61, etc.)
 * @returns {string} - Short label (FE, FEE, NCE, etc.)
 */
export const getDteAbbreviation = code => {
  // Convertimos a número para asegurar la comparación correcta si el input es string
  switch (Number(code)) {
    case 33:
      return 'FE'
    case 34:
      return 'FEE'
    case 39:
      return 'BE'
    case 46:
      return 'FCE'
    case 52:
      return 'GDE'
    case 56:
      return 'NDE'
    case 61:
      return 'NCE'
    case 80:
      return 'BHE'
    case 90:
      return 'BHTE'
    case 110:
      return 'FEX'
    default:
      return '-'
  }
}
